import { MatterSubItemContextMenu } from "@/components/features/matter/context-menus/MatterSubItemContextMenu";
import type { Matter } from "@/lib/types";
import type { ReactNode } from "react";

interface MatterTreatmentBillContextMenuProps {
  canDelete: boolean;
  id: string;
  isDeleting: boolean;
  label: string;
  matter: Matter;
  onDelete: () => Promise<void>;
  onEdit: () => void;
  originalBill?: number | null;
  status?: string | null;
  trigger: ReactNode;
}

export const MatterTreatmentBillContextMenu = ({
  canDelete,
  id,
  isDeleting,
  label,
  matter,
  onDelete,
  onEdit,
  originalBill,
  status,
  trigger,
}: MatterTreatmentBillContextMenuProps) => (
  <MatterSubItemContextMenu
    createSignatureRequest
    copyValue={[
      label,
      status ? `Status: ${status}` : undefined,
      originalBill != null ? `Original bill: $${originalBill}` : undefined,
    ]
      .filter(Boolean)
      .join("\n")}
    delete={canDelete ? { disabled: isDeleting, onSelect: onDelete } : false}
    entityLabel={label}
    entityName="treatment bill"
    matter={matter}
    onEdit={onEdit}
    subItem={{ id, type: "medical-treatment-bill" }}
    trigger={trigger}
  />
);
